import { LogoIcon } from "../../assets/imageAssets";

import Input from "../../components/Input";
import Button from "../../components/Buttons/button";
import TextButton from "../../components/Buttons/textButton";

import { useDispatch } from "react-redux";
import { Formik } from "formik";

import { closeModal, openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";

import * as yup from "yup";
import { signUp_req } from "../../api/user.api";
import { useState } from "react";
import Alert from "../../components/Alert";

const SignUpModal = () => {
  const dispatch = useDispatch();
  let EMAIL_REGX = /^[\w+.-]+@[\w.-]+\.\w{2,3}$/;
  const signUpScheme = yup.object().shape({
    username: yup
      .string()

      .required("This field is required")
      .matches(/^[^\s]/, "Username cannot start with a space"),
    email: yup
      .string()
      .required("This field is required")
      .matches(EMAIL_REGX, "Incorrect email format")
      .email("Incorrect email format"),

    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must have at least one uppercase letter")
      .matches(/[a-z]/, "Password must have at least one lowercase letter")
      .matches(/\d/, "Password must have at least one digit")
      .matches(
        /[@$!%*?&_.]/,
        "Password must have at least one special symbol (@, $, !, %, *, ?, &, _, .)"
      )
      .required("Password is required"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), undefined], "Passwords must match")
      .required("Confirm password is required"),
  });
  const [errorData, setErrorData] = useState("");
  const signUp = async (data) => {
    try {
      const response = await signUp_req(data);

      if (response) {
        dispatch(closeModal({}));

        dispatch(
          openModals({
            modalIds: [ModalsEnum.CHECK_EMAIL_SIGNUP_MODAL],
            modalData: {
              className: "check-email-modal",
              email: [data?.email],
            },
          })
        );
      }
    } catch (e) {
      console.log("e", e);
      setErrorData(e?.response?.data?.errors?.email);
    }
  };

  const handleSignIn = () => {
    dispatch(closeModal({}));

    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_IN_MODAL],
      })
    );
  };

  const closePopup = () => {
    dispatch(closeModal({}));
  };

  return (
    <>
      <div className="modal-header">
        <div className="modal-title flex flex-align-center mb-16">
          <img
            src={LogoIcon}
            alt="Logo"
          />
          <h4>Sign Up to Continue</h4>
        </div>
        <p className="medium-text text-color-grey">
          Track your data, get deeper insights, and access your report anytime —
          all with a free account.
        </p>
      </div>
      <div className="modal-body">
        <p className="have-account-question medium-text text-color-grey-700 mb-20">
          Already have an account?
          <TextButton
            text={"Log in"}
            className={"ml-8"}
            onClick={handleSignIn}
          />
        </p>

        <Formik
          initialValues={{
            username: "",
            email: "",
            password: "",
            password_confirmation: "",
          }}
          validateOnMount={true}
          onSubmit={(values) => signUp(values)}
          validationSchema={signUpScheme}
        >
          {({ handleChange, handleSubmit, values, touched, errors }) => {
            return (
              <>
                <Input
                  id={"username"}
                  name={"username"}
                  label={"Username"}
                  onChange={handleChange}
                  placeholder={"Enter your username"}
                  className="mb-16"
                  errorMessage={
                    touched?.username && errors?.username && errors.username
                  }
                />
                <Input
                  id={"email"}
                  label={"Email"}
                  placeholder={"Enter your email"}
                  name={"email"}
                  type={"email"}
                  className="mb-16"
                  onChange={handleChange}
                  // errorMessage={errorData}
                  errorMessage={
                    (touched?.email && errors?.email && errors.email) ||
                    errorData
                  }
                />
                <Input
                  id={"password"}
                  label={"Password"}
                  placeholder={"Enter your password"}
                  name={"password"}
                  type={"password"}
                  className="mb-16"
                  onChange={handleChange}
                  errorMessage={
                    touched?.password && errors?.password && errors.password
                  }
                />

                <Input
                  id={"password_confirmation"}
                  label={"Repeat Password"}
                  placeholder={"Confirm your password"}
                  name={"password_confirmation"}
                  type={"password"}
                  className="mb-16"
                  onChange={handleChange}
                  errorMessage={
                    touched?.password_confirmation &&
                    errors?.password_confirmation &&
                    errors.password_confirmation
                  }
                />
                <div className="modal-footer flex flex-align-center">
                  <Button
                    text={"Cancel"}
                    type={"outline"}
                    className={"mr-16"}
                    fullWidth={true}
                    onClick={closePopup}
                  />
                  <Button
                    text={"Get Started"}
                    fullWidth={true}
                    onClick={handleSubmit}
                  />
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default SignUpModal;
